export default "__VITE_ASSET__D5Q57xCA__"